import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

// Fetch the signed-in user's saved email signature once. `reload` re-pulls it after a save.
export function useSignature() {
  const [sig, setSig] = useState({ html: "", enabled: true, loaded: false });
  const reload = useCallback(() => {
    api.get("/email/signature")
      .then((r) => setSig({ html: r.data.html || "", enabled: r.data.enabled !== false, loaded: true }))
      .catch(() => setSig((s) => ({ ...s, loaded: true })));
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return { ...sig, reload };
}

// Escape + preserve line breaks — MUST mirror the backend `_text_to_html` so the preview
// matches exactly what Gmail will send.
export function bodyToHtml(text) {
  const esc = (text || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return esc.replace(/\r\n/g, "\n").replace(/\n/g, "<br>");
}

// Exactly what the recipient will receive: the typed body + the signature (when enabled).
export function previewHtml(text, sig) {
  const body = bodyToHtml(text);
  if (sig && sig.enabled && (sig.html || "").trim()) return `${body}<br><br>${sig.html}`;
  return body;
}

export const TONES = [
  { key: "brief", label: "Brief" },
  { key: "warm", label: "Warm" },
  { key: "formal", label: "Formal" },
];
